import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import ResellerRoute from './components/ResellerRoute';

// Pages
import LandingPage from './pages/LandingPage';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConfirmEmailChange from './pages/ConfirmEmailChange';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Dashboard from './pages/Dashboard';
import MyServices from './pages/MyServices';
import SelectPlan from './pages/SelectPlan';
import OrderService from './pages/OrderService';
import ServerManagement from './pages/ServerManagement';
import TopUp from './pages/TopUp';
import DepositsHistory from './pages/DepositsHistory';
import Profile from './pages/Profile';
import FAQ from './pages/FAQ';
import ResellerApi from './pages/ResellerApi';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminServers from './pages/admin/AdminServers';
import AdminTransactions from './pages/admin/AdminTransactions';
import Status from './pages/Status';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import RevealObserver from './components/RevealObserver';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <RevealObserver />
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirm-email-change" element={<ConfirmEmailChange />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/services" element={<PrivateRoute><MyServices /></PrivateRoute>} />
          <Route path="/select-plan" element={<PrivateRoute><SelectPlan /></PrivateRoute>} />
          <Route path="/order" element={<PrivateRoute><OrderService /></PrivateRoute>} />
          <Route path="/server/:id" element={<PrivateRoute><ServerManagement /></PrivateRoute>} />
          <Route path="/topup" element={<PrivateRoute><TopUp /></PrivateRoute>} />
          <Route path="/deposits" element={<PrivateRoute><DepositsHistory /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/faq" element={<PrivateRoute><FAQ /></PrivateRoute>} />
          <Route path="/status" element={<Status />} />

          <Route
            path="/reseller-api"
            element={
              <PrivateRoute>
                <ResellerRoute>
                  <ResellerApi />
                </ResellerRoute>
              </PrivateRoute>
            }
          />
          
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
          <Route path="/admin/servers" element={<AdminRoute><AdminServers /></AdminRoute>} />
          <Route path="/admin/transactions" element={<AdminRoute><AdminTransactions /></AdminRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
